import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Comparable from './Comparable'
import ContentHolder from '../../ui/ContentHolder'
import styles from './styles.scss'

class Comparables extends Component {
  _renderComparables = () => {
    const { campaignComparables, brand } = this.props

    return campaignComparables.map((comparable, index) => {
      const showLarge = index === 0
      return <Comparable key={comparable.id} campaignComparable={comparable} brand={brand} large={showLarge} />
    })
  }

  render(){
    const { campaignComparables, title } = this.props

    if (!campaignComparables.length){
      return null
    }

    return (
      <div className={styles.root}>
        <ContentHolder>
          <h2 className={styles.title}>{title}</h2>
          <div className={styles.comparables}>{this._renderComparables()}</div>
        </ContentHolder>
      </div>
    )
  }
}

Comparables.propTypes = {
  brand: PropTypes.object.isRequired,
  campaignComparables: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
}

export default Comparables
